import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import Button from 'ati-ui-react/components/Button';

import { GovNumButtonContainer } from './GovNumButtonStyles';

const GovNumVinButton: FC = observer(() => {
  const {
    advertsStore: {
      // @ts-ignore
      currentAdvert: { unique_numbers_available },
    },
    checksStore: {
      getGovNumVin,
      setShowPopupGovNumVin,
      setDesciption,
      statusGettingUniqueNumbersAccess,
      buyingFullReportStatus,
      setUniqueNumbersAvailable,
    },
    profileStore: { isUser },
    popupStore: { openLoginPopup },
  } = useStores();

  useEffect(() => {
    getGovNumVin();
  }, []);

  useEffect(() => {
    if (statusGettingUniqueNumbersAccess.isSuccess || buyingFullReportStatus.isSuccess) {
      setUniqueNumbersAvailable(true);
    }
  }, [statusGettingUniqueNumbersAccess.state, buyingFullReportStatus.state]);

  if (unique_numbers_available || unique_numbers_available === undefined) {
    return null;
  }

  const onHandleShowPopupGovNumVin = () => {
    if (!isUser) return openLoginPopup();

    return setShowPopupGovNumVin();
  };

  return (
    <GovNumButtonContainer>
      <Button onClick={onHandleShowPopupGovNumVin} className="button">
        {setDesciption()}
      </Button>
    </GovNumButtonContainer>
  );
});

export default GovNumVinButton;
